import React, { useContext, useState } from "react";
import { Request } from "../../api/customers/Customer.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import Success from "../../components/Success";

const EditCustomerContainer = ({ customer, children }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [success, setSuccess] = useState(false);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);

    // values.cap = String(values.cap);
    let params = values;
    if (!values.profile) {
      params.profile = customer;
      // customer.profile.cap = customer.profile.cap.toString()
    }

    Request.updateCustomer(token.access, {
      ...params,
      ...params.profile,
      customer: customer.profile.id,
    })
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setSuccess(true);
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  const onCloseSuccesPopup = () => {
    setSuccess(null);
  };

  return (
    <>
      {error ? <Error message={error} /> : null}
      {loading ? <Loading /> : loading}
      {success ? (
        <Success
          message="Your data has been updated."
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      {customer ? children({ onSubmit, customer }) : null}
    </>
  );
};

export default EditCustomerContainer;
